import {onFind, initInScope } from "@elements/init-modules-in-scope";
import {on, findAllIn} from "@elements/dom-utils";


const defaultSelectors = {
    base: '.js-product-grid',
    select: '.js-product-grid__param-reset-select',
};

export function init(selectors = defaultSelectors) {
    //console.log('init');
    onFind(selectors.base, (baseElement) => {
        //console.log('onFind');
        attachSelectChangeListeners(baseElement, selectors);

        on('product-grid.success', function () {
            console.log('change baseElement');
            attachSelectChangeListeners(baseElement, selectors);
        }, baseElement);
    });

    function attachSelectChangeListeners(baseElement, selectors) {
        let resetSelect = findAllIn(selectors.select, baseElement);
        resetSelect.forEach(function (item) {
            on('change', function () {
                console.log('change Select');
                let paramName = item.getAttribute('data-param-reset-name');
                let params = new URLSearchParams(window.location.search);
                params.delete(paramName);

                let newUrl = window.location.pathname + '?' + params.toString();
                window.history.replaceState({}, '', newUrl);
            }, item);
        });
    }
};